import { ConfigFilterFacet, Filter } from "@usereactify/search";
import React from "react";
import { FiltersBox } from "./FiltersBox";

type FilterContentProps = {
  filter: ConfigFilterFacet;
  isSizeGuide: boolean;
  handleChange: React.Dispatch<React.SetStateAction<boolean>>;
};

const FilterContent = (props: FilterContentProps) => {
  const { filter, isSizeGuide, handleChange } = props;

  return (
    <Filter
      key={filter.id}
      filter={filter}
      renderFilterList={({ filterListProps }) => {
        return (
          <>
            <ul className="no-bullets tag-list tag-list--active-tags">
              <FiltersBox filterListProps={filterListProps} isSizeGuide={isSizeGuide} setFilterOpen={handleChange} />
              {/* Box View */}
              {filter.displayView === "box" && (
                <FiltersBox filterListProps={filterListProps} isSizeGuide={isSizeGuide} setFilterOpen={handleChange} />
              )}
            </ul>
          </>
        );
      }}
    />
  );
};

export default FilterContent;
